/**
 * @generated SignedSource<<bb02ad86a582d2a32b935dc3408acf29>>
 * @relayHash cdb67611d81cf2085b23d91e436c89e5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cdb67611d81cf2085b23d91e436c89e5

import { ConcreteRequest } from 'relay-runtime';
export type chPatientByPatientIdQuery$variables = {
  patientId: string;
};
export type chPatientByPatientIdQuery$data = {
  readonly patientByPatientId: {
    readonly id: string;
  } | null;
};
export type chPatientByPatientIdQuery = {
  response: chPatientByPatientIdQuery$data;
  variables: chPatientByPatientIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "alias": "patientByPatientId",
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "concreteType": "ch_Patient",
    "kind": "LinkedField",
    "name": "ch_patientByPatientId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chPatientByPatientIdQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chPatientByPatientIdQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "cdb67611d81cf2085b23d91e436c89e5",
    "metadata": {},
    "name": "chPatientByPatientIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6546f4325c0ebea62aded929eafb7b6f";

export default node;
